import { render, staticRenderFns } from "./AddBillOfLadingDetail.vue?vue&type=template&id=2a7b4f14"
import script from "./AddBillOfLadingDetail.vue?vue&type=script&lang=js"
export * from "./AddBillOfLadingDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports